import axios, { CreateAxiosDefaults } from 'axios';
import {
  getApiServerUrl,
  getFooterApiServerUrl
} from '../shared/utils/mandant';
import { DestinationSources } from './hooks/useDestinations';
import { isBearerTokenAuthEnabled } from '../shared/hooks/auth';

export const behBaseUrl = `${getApiServerUrl()}/api/v1`;
export const behBaseFooterUrl = `${getFooterApiServerUrl()}/api/v1`;

export const BehApiRoutes = {
  bundId: () => `/zbp`,
  allCases: () => '/cases',
  case: (caseId: string) => `/cases/${caseId}`,
  profile: () => '/profile',
  caseSubmissions: (caseId: string) => `/cases/${caseId}/submissions`,
  vermerkByCaseId: (caseId: string) => `/cases/${caseId}/vermerke`,
  vermerkByIdAndCaseId: (caseId: string, vermerkId: string) =>
    `/cases/${caseId}/vermerke/${vermerkId}`,
  attachmentByIdAndSubmission: (
    caseId: string,
    submissionId: string,
    attachmentId: string
  ) =>
    `/cases/${caseId}/submissions/${submissionId}/attachments/${attachmentId}/download`,
  caseAttachments: (caseId: string) => `/cases/${caseId}/attachments`,
  caseAttachmentSummary: (caseId: string, attachmentIds?: string) =>
    attachmentIds
      ? `/cases/${caseId}/summary?attachmentIds=${attachmentIds}`
      : `/cases/${caseId}/summary`,
  configurationBaseUri: () => `/configuration`,
  fitConnectClientInformation: () =>
    `/configuration/fitConnectClientInformation`,
  caseWeiterleitungAttempt: (caseId: string, submissionId: string) =>
    `/cases/${caseId}/submissions/${submissionId}/forwardings/attempt`,
  caseWeiterleitung: (caseId: string, submissionId: string) =>
    `/cases/${caseId}/submissions/${submissionId}/forwardings`,
  messageRead: (caseId: string, submissionId: string, userId: string) =>
    `/cases/${caseId}/submissions/${submissionId}/users/${userId}`,
  userFromOrgUnit: (orgUnitName: string) => `/users?orgUnitName=${orgUnitName}`,
  footer: () => `/footers`,
  userRoles: () => `/config/usersRoles`,
  casesCount: () => '/cases/count',
  logo: () => '/configuration/logo',
  summary: () => '/configuration/summary',
  configurationStep: () => '/configuration/configurationStep',
  datamodels: (destinationIds?: Array<string>) =>
    (destinationIds?.length ?? 0) > 0
      ? `/configuration/datamodels?destination-ids=${destinationIds?.join(',')}`
      : `/configuration/datamodels`,
  datamodelsList: (identifiers?: string[]) =>
    `/datamodels${identifiers ? '?identifiers' : ''}`,
  destinations: (source?: DestinationSources) =>
    source
      ? `/configuration/destinations?source=${source}`
      : `/configuration/destinations`,
  vermerk: (caseId: string, vermerkId: string) =>
    `/cases/${caseId}/vermerke/${vermerkId}/verlauf`,
  fitConnectSenderInformation: () =>
    `/configuration/fitConnectSenderInformation`,
  orgUnits: () => `/orgunits`,
  orgUnitById: (orgUnitId: string) => `/orgunits/${orgUnitId}`,
  publicServicesByOrgUnit: (orgUnitId: string) =>
    `/orgunits/${orgUnitId}/public-services`,
  publicServicesByIdAndByOrgUnit: (
    orgUnitId: string,
    publicServiceId: string
  ) => `/orgunits/${orgUnitId}/public-services/${publicServiceId}`,
  fowardingsByPublicServicesByIdAndByOrgUnit: (
    orgUnitId: string,
    publicServiceId: string
  ) => `/orgunits/${orgUnitId}/public-services/${publicServiceId}/forwardings`,
  forwardingsByOrgUnit: (orgUnitId: string) =>
    `/orgunits/${orgUnitId}/forwardings`,
  userInvite: () => '/config/userInvite',
  userById: (userId: string) => `/users/${userId}`,
  users: () => '/users',
  availableRoles: () => `/usermanagement/roles`,
  userWithAuthorizations__: (page: number, size: number) =>
    `/usermanagement/users?page=${page}&size=${size}`,
  inviteUser: () => `/usermanagement/users/invite`,
  setUserRoles: (userId: string) => `/usermanagement/users/${userId}/roles`,
  removeUser: (userId: string) => `/usermanagement/users/${userId}`,
  scheduledTasks: (taskNameFilter?: string) =>
    taskNameFilter
      ? `/scheduled-tasks?taskNameFilter=${taskNameFilter}`
      : `/scheduled-tasks`,
  fitconnectPublicKey: (destinationId: string, kid: string) =>
    `/configuration/destinations/${destinationId}/fitconnect-public-key/${encodeURIComponent(kid)}`,
  adminTasks: () => `/admin-tasks`,
  destinationsLastSync: () => `/configuration/destinations/last-sync`,
  versandCancel: (caseId: string, submissionId: string) =>
    `/cases/${caseId}/submissions/${submissionId}/dispatch/cancellation`,
  versandRetry: (caseId: string, submissionId: string) =>
    `/cases/${caseId}/submissions/${submissionId}/dispatch/retry`,
  versandPostal: (caseId: string, submissionId: string) =>
    `/cases/${caseId}/submissions/${submissionId}/dispatch/postal`,
  versandDelete: (caseId: string, submissionId: string) =>
    `/cases/${caseId}/submissions/${submissionId}/dispatch`
};

axios.defaults.baseURL = behBaseUrl;

export const apiConfig: CreateAxiosDefaults = {
  baseURL: behBaseUrl,
  headers: {
    ...axios.defaults.headers
  },
  withCredentials: !isBearerTokenAuthEnabled()
};

export const behClient = axios.create(apiConfig);
